import { render, staticRenderFns } from "./CustomFormRecordEdit.vue?vue&type=template&id=04f45d11"
import script from "./CustomFormRecordEdit.js?vue&type=script&lang=js&external"
export * from "./CustomFormRecordEdit.js?vue&type=script&lang=js&external"
import style0 from "./CustomFormRecordEdit.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./CustomFormRecordEdit.vue?vue&type=style&index=1&id=04f45d11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports